import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { Container } from "@/components/site/Bits";

export default function FinalCTA() {
  return (
    <section className="border-t border-pg-border bg-white py-16 md:py-20" data-testid="final-cta">
      <Container>
        <div className="rounded-lg border border-pg-border bg-pg-pale px-6 py-10 md:px-12 md:py-14">
          <div className="grid gap-8 md:grid-cols-[1.4fr_1fr] md:items-center">
            <div>
              <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-pg-primary">
                <ShieldCheck className="h-4 w-4" /> Next step
              </p>
              <h2 className="mt-4 text-2xl md:text-3xl font-bold text-pg-dark">
                Not sure which inspection you need? Start with a few questions.
              </h2>
              <p className="mt-3 max-w-xl text-sm md:text-base text-pg-muted leading-relaxed">
                Tell us what you are seeing and we will set out what is likely, what is uncertain and
                which inspection would answer the question. Speak to us on 0333 335 6152 if you would
                rather talk it through.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <Link
                to="/tools/check-my-damp"
                data-testid="cta-check-my-damp"
                className="flex items-center justify-between rounded-md bg-pg-primary px-5 py-3.5 text-sm font-semibold text-white hover:bg-pg-dark transition-colors"
              >
                Check My Damp <ArrowRight className="h-4 w-4" />
              </Link>
              <Link
                to="/book-an-inspection"
                data-testid="cta-book-inspection"
                className="flex items-center justify-between rounded-md border border-pg-primary bg-white px-5 py-3.5 text-sm font-semibold text-pg-primary hover:bg-pg-pale transition-colors"
              >
                Book an Inspection <ArrowRight className="h-4 w-4" />
              </Link>
              <a
                href="tel:03333356152"
                className="flex items-center justify-between rounded-md border border-pg-border bg-white px-5 py-3.5 text-sm font-semibold text-pg-dark hover:border-pg-primary transition-colors"
              >
                0333 335 6152 <ArrowRight className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
